import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CombineHsvSockets} from "#material/nodes/converter/combine-hsv/definition"
import {combineHsvDefinition} from "#material/nodes/converter/combine-hsv/definition"
import {threeHsvToRgb, threeValue} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {ThreeTsl as TSL} from "#material/three/exports"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {ThreeReturns} from "#material/sockets/three"
import type {CombineHsvNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class CombineHsv extends MaterialNode<CombineHsvSockets> {
    public override get definition() {
        return combineHsvDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<CombineHsvSockets>> => {
        const {h, s, v} = await evaluator.getAll({
            h: this.parameters.inputs.h,
            s: this.parameters.inputs.s,
            v: this.parameters.inputs.v,
        })
        const hValue = h?.toFloat() ?? threeValue(this.parameters.settings.h ?? 0)
        const sValue = s?.toFloat() ?? threeValue(this.parameters.settings.s ?? 0)
        const vValue = v?.toFloat() ?? threeValue(this.parameters.settings.v ?? 0)

        return {image: threeHsvToRgb(TSL.vec3(hValue, sValue, vValue))}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<CombineHsvSockets>> => {
        const combineHsvNode: CombineHsvNode = {
            type: "combine_hsv",
            inputs: await evaluator.getAll({
                h: this.parameters.inputs.h,
                s: this.parameters.inputs.s,
                v: this.parameters.inputs.v,
            }),
            parameters: {
                h: this.parameters.settings.h,
                s: this.parameters.settings.s,
                v: this.parameters.settings.v,
            },
            resources: {},
        }

        return {image: [combineHsvNode, "color"]}
    }
}
